import React from 'react';

import sectionRedEffect from '../../../main/assets/images/fpvAce/Boxes_content_bg.webp';
import sectionRedEffectVertical from '../../../main/assets/images/fpvAce/Boxes_content_vertical_bg.webp';
import bgCardNoise from '../../../main/assets/images/skydive/cards-noise-effect.png';

const factsData = [
  {
    description: 'Review ratio on steam with over 2000 reviews.',
    ratingSvg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="169"
        height="61"
        viewBox="0 0 169 61"
        fill="none"
      >
        <path
          d="M143.905 5.55615C159.137 5.55615 168.929 14.3882 168.929 28.0202C168.929 41.6522 159.137 50.4842 143.905 50.4842C128.673 50.4842 118.945 41.6522 118.945 28.0202C118.945 14.3882 128.673 5.55615 143.905 5.55615ZM143.905 16.1161C136.993 16.1161 133.025 20.3402 133.025 28.0202C133.025 35.7002 136.993 39.9242 143.905 39.9242C150.881 39.9242 154.849 35.7002 154.849 28.0202C154.849 20.3402 150.881 16.1161 143.905 16.1161Z"
          fill="white"
        />
        <path
          d="M94.7743 20.0201H84.4062V11.8921H85.1742C95.1582 11.8921 98.2943 9.84408 99.8303 6.58008H108.982V49.3321H94.7743V20.0201Z"
          fill="white"
        />
        <path
          d="M46.3359 60.02L71.1039 0.5H80.9599L56.1919 60.02H46.3359Z"
          fill="white"
        />
        <path
          d="M46.976 27.2521C46.976 42.1641 36.16 50.4841 19.328 50.4841C14.016 50.4841 8.64 49.8441 0.128 47.2841L3.328 37.1081C9.664 39.1561 15.168 39.7321 18.048 39.7321C22.464 39.7321 26.048 39.0281 28.864 37.6201C31.68 36.2121 33.216 33.6521 33.536 29.9401C29.888 32.0521 24.256 33.6521 19.136 33.6521C10.368 33.6521 0 31.2201 0 20.9801C0 12.0841 8 5.68408 22.208 5.68408C37.184 5.68408 46.976 13.0441 46.976 27.2521ZM13.568 21.4921C13.568 25.2681 17.792 26.4841 22.016 26.4841C26.176 26.4841 30.528 25.3321 33.344 23.5401C32.128 17.3961 25.984 16.3081 22.208 16.3081C17.6 16.3081 13.568 17.9081 13.568 21.4921Z"
          fill="white"
        />
      </svg>
    ),
  },
  {
    description: 'Review ratio on App Store on more than 100 ratings.',
    ratingSvg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="216"
        height="61"
        viewBox="0 0 216 61"
        fill="none"
      >
        <path
          d="M191.109 39.092C197.509 39.092 200.964 37.684 200.964 34.804C200.964 32.436 198.469 30.772 192.645 30.772C188.037 30.772 184.324 31.732 181.572 32.692L169.796 30.516L171.781 6.70801H213.572C213.06 14.324 212.036 17.716 205.764 17.716H183.876L183.109 25.908C186.501 24.628 191.684 23.156 197.508 23.156C208.965 23.156 215.428 27.7 215.428 35.38C215.428 44.852 207.237 50.356 191.365 50.356C183.941 50.356 174.981 48.82 167.812 46.196L171.844 35.7C178.948 38.068 185.669 39.092 191.109 39.092Z"
          fill="white"
        />
        <path
          d="M130.273 60.02L155.041 0.5H164.897L140.129 60.02H130.273Z"
          fill="white"
        />
        <path
          d="M106.969 5.68408C113.433 5.68408 118.425 6.90008 121.945 9.26808C125.465 11.7001 127.257 14.7721 127.257 18.4841C127.257 26.5481 121.177 28.9161 107.993 32.6921C98.8407 35.3801 97.6247 36.4041 96.9207 38.1321H126.873V49.3321H81.3047V47.1561C81.3047 34.7401 87.0007 28.7881 103.769 23.9881C107.097 23.0281 109.273 22.3241 110.361 21.7481C111.385 21.2361 111.897 20.5321 111.897 19.6361C111.897 17.8441 109.785 16.9481 105.625 16.9481C99.9287 16.9481 92.8247 19.1881 86.3607 22.1961L82.1367 11.8921C90.0087 7.98808 98.2007 5.68408 106.969 5.68408Z"
          fill="white"
        />
        <path
          d="M58.8828 49.3319V38.0679H72.7068V49.3319H58.8828Z"
          fill="white"
        />
        <path
          d="M0 31.22L26.816 6.70801H43.904V31.22H51.584V40.692H43.904V49.332H30.976V40.692H0V31.22ZM14.272 31.22H30.976V15.86L14.272 31.22Z"
          fill="white"
        />
      </svg>
    ),
  },
  {
    description: 'New players on every day on steam & mobile.',
    ratingSvg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="243"
        height="61"
        viewBox="0 0 243 46"
        fill="none"
      >
        <path
          d="M218.037 18.2922V6.32422H228.405V18.2922H242.229V27.6362H228.405V39.6042H218.037V27.6362H204.213V18.2922H218.037Z"
          fill="white"
        />
        <path
          d="M171.249 0.5C186.481 0.5 196.273 9.332 196.273 22.964C196.273 36.596 186.481 45.428 171.249 45.428C156.017 45.428 146.289 36.596 146.289 22.964C146.289 9.332 156.017 0.5 171.249 0.5ZM171.249 11.06C164.337 11.06 160.369 15.284 160.369 22.964C160.369 30.644 164.337 34.868 171.249 34.868C178.225 34.868 182.193 30.644 182.193 22.964C182.193 15.284 178.225 11.06 171.249 11.06Z"
          fill="white"
        />
        <path
          d="M115.374 0.5C130.606 0.5 140.398 9.332 140.398 22.964C140.398 36.596 130.606 45.428 115.374 45.428C100.142 45.428 90.4141 36.596 90.4141 22.964C90.4141 9.332 100.142 0.5 115.374 0.5ZM115.374 11.06C108.462 11.06 104.494 15.284 104.494 22.964C104.494 30.644 108.462 34.868 115.374 34.868C122.35 34.868 126.318 30.644 126.318 22.964C126.318 15.284 122.35 11.06 115.374 11.06Z"
          fill="white"
        />
        <path
          d="M59.4991 0.5C74.7311 0.5 84.5231 9.332 84.5231 22.964C84.5231 36.596 74.7311 45.428 59.4991 45.428C44.2671 45.428 34.5391 36.596 34.5391 22.964C34.5391 9.332 44.2671 0.5 59.4991 0.5ZM59.4991 11.06C52.5871 11.06 48.6191 15.284 48.6191 22.964C48.6191 30.644 52.5871 34.868 59.4991 34.868C66.4751 34.868 70.4431 30.644 70.4431 22.964C70.4431 15.284 66.4751 11.06 59.4991 11.06Z"
          fill="white"
        />
        <path
          d="M10.368 14.9639H0V6.83593H0.768C10.752 6.83593 13.888 4.78793 15.424 1.52393H24.576V44.2759H10.368V14.9639Z"
          fill="white"
        />
      </svg>
    ),
  },
  {
    description: 'Daily active users on all platforms.',
    ratingSvg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="265"
        height="61"
        viewBox="0 0 265 45"
        fill="none"
      >
        <path
          d="M81.4678 0C96.6997 0 106.492 8.83194 106.492 22.4639C106.492 36.0959 96.6998 44.9277 81.4678 44.9277C66.2358 44.9277 56.5078 36.0959 56.5078 22.4639C56.5079 8.83195 66.2358 1.47478e-05 81.4678 0ZM137.343 0C152.575 0 162.367 8.83194 162.367 22.4639C162.367 36.0959 152.575 44.9277 137.343 44.9277C122.111 44.9277 112.383 36.0959 112.383 22.4639C112.383 8.83196 122.111 1.76973e-05 137.343 0ZM193.218 0C208.45 0 218.242 8.83194 218.242 22.4639C218.242 36.0959 208.45 44.9277 193.218 44.9277C177.986 44.9277 168.258 36.0959 168.258 22.4639C168.258 8.83196 177.986 1.76973e-05 193.218 0ZM43.9043 25.6641H51.584V35.1367H43.9043V43.7764H30.9756V35.1367H0V25.6641L26.8164 1.15234H43.9043V25.6641ZM250.372 17.792H264.195V27.1357H250.372V39.1045H240.004V27.1357H226.18V17.792H240.004V5.82422H250.372V17.792ZM81.4678 10.5596C74.5558 10.5596 70.5879 14.784 70.5879 22.4639C70.5879 30.1439 74.5558 34.3681 81.4678 34.3682C88.4438 34.3682 92.4121 30.1439 92.4121 22.4639C92.4121 14.784 88.4437 10.5596 81.4678 10.5596ZM137.343 10.5596C130.431 10.5596 126.463 14.784 126.463 22.4639C126.463 30.1439 130.431 34.3681 137.343 34.3682C144.319 34.3682 148.287 30.1439 148.287 22.4639C148.287 14.784 144.319 10.5596 137.343 10.5596ZM193.218 10.5596C186.306 10.5596 182.338 14.784 182.338 22.4639C182.338 30.1439 186.306 34.3681 193.218 34.3682C200.194 34.3682 204.162 30.1439 204.162 22.4639C204.162 14.784 200.194 10.5596 193.218 10.5596ZM14.2725 25.6641H30.9756V10.3047L14.2725 25.6641Z"
          fill="white"
        />
      </svg>
    ),
  },
];

interface FactCardProps {
  description: string;
  ratingSvg: React.ReactNode;
}

const FactCard: React.FC<FactCardProps> = ({ description, ratingSvg }) => (
  <div className="skydive-facts-card-content">
    <img
      src={bgCardNoise}
      alt="Background Grain Effect"
      className="skydive-cards-card-noise"
    />
    <div className="skydive-facts-card-inner">
      <p className="skydive-facts-card-description">{description}</p>
      <div className="skydive-facts-card-rating">{ratingSvg}</div>
    </div>
  </div>
);

export const ProductFacts = () => {
  const [backgroundImage, setBackgroundImage] = React.useState(
    sectionRedEffect,
  );

  React.useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 767) {
        setBackgroundImage(sectionRedEffectVertical);
      } else {
        setBackgroundImage(sectionRedEffect);
      }
    };

    handleResize();

    window.addEventListener('resize', handleResize);

    // Cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="skydive-facts">
      <img
        src={backgroundImage}
        className="skydive-facts-bg"
        alt="Red Waves Ambiance"
      />
      <div className="skydive-facts-text">
        <h2 className="skydive-facts-title">one fpv simulator</h2>
        <h3 className="skydive-facts-subtitle">
          FPV SkyDive is your gateway into the thrilling world of FPV drone
          racing and freestyle
        </h3>
      </div>
      <div className="skydive-facts-cards">
        {factsData.map((fact, index) => (
          <FactCard key={index} {...fact} />
        ))}
      </div>
    </div>
  );
};
